import React from "react";
import Login from "./components/Login.js";
import Dashboard from "./components/Dashboard.js";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicOnlyRoute from "./components/PublicOnlyRoute";
import AppToastContainer from "./components/AppToastContainer";
import Serviceadd from "./components/Service/Serviceadd";
import List from "./components/Service/List.js";
import Customer from "./components/Customer/Customer.js";
import Blogadd from "./components/Blog/Blogadd.js";
import Bloglist from "./components/Blog/Bloglist.js";
import Upload from "./components/Upload.js";
import Add from "./components/Add/Add.js";
import Banner from "./components/Banner/Banner.js";
import Bannerlist from "./components/Banner/Bannerlist.js";
import News from "./components/News/News.js";
import Newslist from "./components/News/Newslist.js";
import Client from "./components/Client.js";
import Clientlist from "./components/Clientlist.js";
import Adslist from "./components/Add/Adslist.js";
import Subscriberslist from "./components/Subscriberslist.js";
import Professionallist from "./components/Professional/Professionallist.js";
import ServiceCategory from "./components/ServiceCategory.js";
import Contact from "./components/Contact.js";
import Adminregister from "./components/Adminregister.js";
import Testimoniallist from "./components/Testimonial/Testimoniallist.js";
import Projectlist from "./components/Project/Projectlist.js";
import Testimonialadd from "./components/Testimonial/Testimonailadd.js";
import Projectadd from "./components/Project/Projectadd.js";
import Serviceedit from "./components/Service/Serviceedit.js";
import Blogedit from "./components/Blog/Blogedit.js";
import Newsedit from "./components/News/Newsedit.js";
import Projectedit from "./components/Project/Projectedit.js";
import Testimonialedit from "./components/Testimonial/Testimonailedit.js";
import Addedit from "./components/Add/Addedit.js";
import Professionaladd from "./components/Professional/Professionaladd.js";
import Customeradd from "./components/Customer/Customeradd.js";
import Professionaledit from "./components/Professional/Professionaledit.js";
import Customeredit from "./components/Customer/Customeredit.js";
import Enquiry from "./components/Enquiry/Enquiry.js";
import Addadmin from "./components/Addadmin.js";
import Notfound from "./components/Notfound.js";
import Subcatedit from "./components/Subcategory/Subcatedit.js";
import Subcatadd from "./components/Subcategory/Subcatadd.js";
import SubList from "./components/Subcategory/SubList.js";
import Level1list from "./components/Subcategory/List/Level1list.js";
import Level2list from "./components/Subcategory/List/Level2list.js";
import Level3list from "./components/Subcategory/List/Level3list.js";
import Level4list from "./components/Subcategory/List/Level4list.js";
import Editevel1 from "./components/Subcategory/Edit/Editevel1.js";
import Enquiryadd from "./components/Enquiry/Enquiryadd.js";
import Enquiryedit from "./components/Enquiry/Enquiryedit.js";
import ProfessionallistSus from "./components/Professional/ProfessionallistSus.js";
import CustomerSus from "./components/Customer/CustomerSus.js";
import Faqadd from "./components/Faq/Faqadd.js";
import Faqlist from "./components/Faq/Faqlist.js";
import Faqedit from "./components/Faq/Faqedit.js";
import Versionlist from "./components/Version/Versionlist.js";
import Addversion from "./components/Version/Addversion.js";
import Versionedit from "./components/Version/Versionedit.js";
import Banneredit from "./components/Banner/Banneredit.js";
import Bannerview from "./components/Banner/Bannerview.js";
import Blogview from "./components/Blog/Blogview.js";
import Projectview from "./components/Project/Projectview.js";
import Enquiryview from "./components/Enquiry/Enquiryview.js";
import Testimonialview from "./components/Testimonial/Testimonialview.js";
import Adview from "./components/Add/Adview.js";
import Faqview from "./components/Faq/Faqview.js";
import Contactview from "./components/Contactview.js";
import Versionview from "./components/Version/Versionview.js";
import Test from "./components/Test.js";
import SubcategoryView from "./components/Subcategory/SubcategoryView.js";
import Userlist from "./components/Userlist/Userlist.js";
import Professionaluserlist from "./components/Userlist/Professionallist.js";
import Normaluserlist from "./components/Userlist/Normaluserlist.js";
import Userview from "./components/Userlist/Userview.js";
import Suspeneduserlist from "./components/Userlist/Suspeneduserlist.js";
import Unverifiedpro from "./components/Userlist/Unverifiedpro.js";
import Propertytypelist from "./components/Property/Propertytypelist.js";
import Propertytypeadd from "./components/Property/Propertytypeadd.js";
import Propertytypeedit from "./components/Property/Propertytypeedit.js";
import Propertytypeview from "./components/Property/Propertytypeview.js";
import Propertyedit from "./components/Properties/Propertyedit.js";
import Propertyadd from "./components/Properties/Propertyadd.js";
import Propertylist from "./components/Properties/Propertylist.js";
import Propertyview from "./components/Properties/Propertyview.js";
import Customerlist from "./components/Userlist/Customerlist.js";
import Propertylistrent from "./components/Properties/Propertylistrent.js";
import Aminitylist from "./components/Aminities/Aminitylist.js";
import Videocreate from "./components/Youtube/Videocreate.js";
import Videolist from "./components/Youtube/Videolist.js";
import Videoedit from "./components/Youtube/Videoedit.js";
import Videoview from "./components/Youtube/Videoview.js";
import Socialhubview from "./components/Socialhub/Socialhubview.js";
import Socialhub from "./components/Socialhub/Socialhub.js";
import Socialhubcreate from "./components/Socialhub/Socialhubcreate.js";
import Socialhubedit from "./components/Socialhub/Socialhubedit.js";
import Draftlist from "./components/Blog/Draftlist.js";
import Contactrequest from "./components/Contactrequest.js";

// import Servicedit from "./components/Servicedit.js";

function App() {
  return (
    <>
      <Router>
        <AppToastContainer />
        <Routes>
          <Route element={<PublicOnlyRoute />}>
            <Route path="/" element={<Login />} />
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/add" element={<Serviceadd />} />
            <Route path="/professionalist" element={<Professionallist />} />
            <Route path="/addblog" element={<Blogadd />} />
            <Route path="/bloglist" element={<Bloglist />} />
            <Route path="/customerdetails" element={<Customer />} />
            <Route path="/user-suspend" element={<CustomerSus />} />
            <Route path="/professional-suspend" element={<ProfessionallistSus />} />
            <Route path="/aminities" element={<Aminitylist />} />
            <Route path="/professionaluserlist" element={<Professionaluserlist />} />
            <Route path="/normaluserlist" element={<Normaluserlist />} />
            <Route path="/servicelist" element={<List />} />
            <Route path="/property-type-list" element={<Propertytypelist />} />
            <Route path="/property-list" element={<Propertylist />} />
            <Route path="/property-list-rent" element={<Propertylistrent />} />
            <Route path="/videos" element={<Videolist />} />
            <Route path="/socialhub" element={<Socialhub />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/addbanner" element={<Banner />} />
            <Route path="/addnews" element={<News />} />
            <Route path="/addfaq" element={<Faqadd />} />
            <Route path="/versions-add" element={<Addversion />} />
            <Route path="/addtestimonail" element={<Testimonialadd />} />
            <Route path="/addproject" element={<Projectadd />} />
            <Route path="/addadmin" element={<Addadmin />} />
            <Route path="/addsubcategory" element={<Subcatadd />} />
            <Route path="/addenquiry" element={<Enquiryadd />} />
            <Route path="/professionaladd" element={<Professionaladd />} />
            <Route path="/useradd" element={<Customeradd />} />
            <Route path="/adds-property-type" element={<Propertytypeadd />} />
            <Route path="/add-property" element={<Propertyadd />} />
            <Route path="/video-add" element={<Videocreate />} />
            <Route path="/socialhub-add" element={<Socialhubcreate />} />
            <Route path="/servicecategory" element={<ServiceCategory />} />
            <Route path="/addclient" element={<Client />} />
            <Route path="/clientlist" element={<Clientlist />} />
            <Route path="/newslist" element={<Newslist />} />
            <Route path="/ads" element={<Add />} />
            <Route path="/faq" element={<Faqlist />} />
            <Route path="/versions" element={<Versionlist />} />
            <Route path="/subscribers" element={<Subscriberslist />} />
            <Route path="/bannerlist" element={<Bannerlist />} />
            <Route path="/adslist" element={<Adslist />} />
            <Route path="/testimoniallist" element={<Testimoniallist />} />
            <Route path="/projectlist" element={<Projectlist />} />
            <Route path="/contactlist" element={<Contact />} />
            <Route path="/contactrequest" element={<Contactrequest />} />
            <Route path="/subcategorylist" element={<SubList />} />
            <Route path="/level1/:id" element={<Level1list />} />
            <Route path="/level2/:id" element={<Level2list />} />
            <Route path="/level3/:id" element={<Level3list />} />
            <Route path="/level4/:id" element={<Level4list />} />
            <Route path="/enquiry" element={<Enquiry />} />
            <Route path="/register" element={<Adminregister />} />
            <Route path="/editservice/:id" element={<Serviceedit />} />
            <Route path="/editblog/:id" element={<Blogedit />} />
            <Route path="/editnews/:id" element={<Newsedit />} />
            <Route path="/editproject/:id" element={<Projectedit />} />
            <Route path="/edittestim/:id" element={<Testimonialedit />} />
            <Route path="/editprofessional/:id" element={<Professionaledit />} />
            <Route path="/editad/:id" element={<Addedit />} />
            <Route path="/editfaq/:id" element={<Faqedit />} />
            <Route path="/editbanner/:id" element={<Banneredit />} />
            <Route path="/edit-property-type/:id" element={<Propertytypeedit/>} />
            <Route path="/edit-property/:id" element={<Propertyedit/>} />
            <Route path="/edit-video/:id" element={<Videoedit/>} />
            <Route path="/edit-socialhub/:id" element={<Socialhubedit/>} />
            <Route path="/editcustomer/:id" element={<Customeredit />} />
            <Route path="/editsubcategory/:id" element={<Subcatedit />} />
            <Route path="/editenquiry/:id" element={<Enquiryedit />} />
            <Route path="/editversion/:id" element={<Versionedit />} />
            <Route path="/editlevel1/:id" element={<Editevel1 />} />
            <Route path="/bannerview/:id" element={<Bannerview />} />
            <Route path="/blogview/:id" element={<Blogview />} />
            <Route path="/projectview/:id" element={<Projectview />} />
            <Route path="/enquiryview/:id" element={<Enquiryview />} />
            <Route path="/testimonialview/:id" element={<Testimonialview />} />
            <Route path="/adsview/:id" element={<Adview />} />
            <Route path="/faqview/:id" element={<Faqview />} />
            <Route path="/contactview/:id" element={<Contactview />} />
            <Route path="/versionview/:id" element={<Versionview />} />
            <Route path="/subcategoryview/:id" element={<SubcategoryView />} />
            <Route path="/property-type-view/:id" element={<Propertytypeview/>} />
            <Route path="/property-view/:id" element={<Propertyview/>} />
            <Route path="/video-view/:id" element={<Videoview/>} />
            <Route path="/socialhub-view/:id" element={<Socialhubview/>} />
            <Route path="/userview/:id" element={<Userview />} />
            <Route path="/userlist" element={<Userlist />} />
            <Route path="/draftlist" element={<Draftlist />} />
            <Route path="/customerlist" element={<Customerlist />} />
            <Route path="/suspendedlist" element={<Suspeneduserlist />} />
            <Route path="/unverifiedprofessional" element={<Unverifiedpro />} />
            <Route path="/test" element={<Test />} />
          </Route>

          <Route path="/*" element={<Notfound />} />
        </Routes>

     
      </Router>
    </>
  );
}
export default App;
